import React, { useMemo } from 'react';
import { TabPane } from 'reactstrap';
import { TABS } from '../..';
import { AutoSizer, List } from 'react-virtualized';
import QueueTag from '../QueueTag';
import { useSocketConversationChatTs } from 'hooks/useSocketConversationChatTs';
import { PullChatButton } from 'components/Buttons/PullChatButton';
import { verifyRoles } from 'components/Authentication/VerifyRoles';

export const TabChatsInWait = ({
  chats = [],
  queues,
  idNameTags,
  answerConversation,
  currentOpenChatId
}) => {
  const { getMaxPullChatConfigFromLocalStorage } =
    useSocketConversationChatTs();

  const maxPullChatConfig = useMemo(getMaxPullChatConfigFromLocalStorage, [
    getMaxPullChatConfigFromLocalStorage
  ]);

  return (
    <TabPane
      tabId={TABS.IN_WAIT}
      style={{
        width: '100%',
        height: '94%'
      }}
    >
      {maxPullChatConfig?.active && verifyRoles(['PULL_CHAT']) ? (
        <div
          style={{
            background: 'rgb(243, 244, 246)',
            padding: '1rem',
            borderRadius: '.5rem',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
            justifyContent: 'center'
          }}
        >
          <h4>Listagem de conversas em espera desativada</h4>
          <span style={{ fontSize: '12px' }}>
            Clique no botão abaixo para resgatar novas conversas
          </span>

          <span style={{ marginTop: '.75rem' }}>
            <PullChatButton />
          </span>
        </div>
      ) : (
        <AutoSizer>
          {({ width, height }) => (
            <List
              style={{
                scrollbarWidth: 'thin',
                margin: '0px',
                padding: '0px'
              }}
              width={width}
              height={height}
              rowHeight={138}
              rowCount={chats?.length || 0}
              rowGetter={({ index }) => chats[index] || {}}
              rowRenderer={({ key, index, style }) => {
                return (
                  <>
                    <div key={key} style={style}>
                      <QueueTag
                        key={key}
                        style={style}
                        allQueues={queues}
                        idNameTags={idNameTags}
                        isSelected={chats[index]?._id === currentOpenChatId}
                        conversation={chats[index]}
                        functionAnswerConversation={answerConversation}
                      />
                    </div>
                  </>
                );
              }}
            />
          )}
        </AutoSizer>
      )}
    </TabPane>
  );
};
